import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { ILessonModel } from 'models/lesson.model'

export const LESSONS_ORDER_EDIT = 'LESSONS_ORDER_EDIT'
export const LESSON_EDIT = 'LESSON_EDIT'
export const GET_LESSON = 'GET_LESSON'
export const GET_LESSON_SUCCESS = 'GET_LESSON_SUCCESS'
export const LESSONS_DESTROY = 'LESSONS_DESTROY'
export const LESSONS_LIST_RELOAD = 'LESSONS_LIST_RELOAD'
export const CREATE_LESSON = 'CREATE_LESSON'
export const SHOW_WARNING_LESSON = 'SHOW_WARNING_LESSON'

export const Actions = {
  getLesson: (lessonsId: number) => createAction(GET_LESSON, lessonsId),
  getLessonSuccess: (data: ILessonModel) => createAction(GET_LESSON_SUCCESS, data),
  lessonsOrderEdit: (data: ILessonModel[]) => createAction(LESSONS_ORDER_EDIT, data),
  lessonEdit: (lessonId: number, data: ILessonModel) => createAction(LESSON_EDIT, { lessonId, data }),
  lessonsDelete: (courseId: string, lessonId: number) => createAction(LESSONS_DESTROY, { courseId, lessonId }),
  lessonListReload: (lessons: ILessonModel[]) => createAction(LESSONS_LIST_RELOAD, lessons),
  lessonCreate: (lesson: ILessonModel, courseId: number, history: any) => createAction(CREATE_LESSON, { lesson, courseId, history }),
  showWarningLesson: (show: boolean) => createAction(SHOW_WARNING_LESSON, show),
}

export type Actions = ActionsUnion<typeof Actions>
